export default function getImageUrl(path = "") {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("https")) return path;

  return `${process.env.REACT_APP_SERVER_URL}/uploads/${path}`;
}
